import { Navigate, Outlet, useLocation } from 'react-router-dom';

import TokenType from '@lib/core/src/enums/TokenType';

import RoutesMap from '@/enums/RoutesMap';

const allowedRoutes = [RoutesMap.Login, RoutesMap.ForgotPassword, RoutesMap.SignUp];

export const ProtectedRoute = () => {
  const { pathname } = useLocation();
  const idToken = localStorage.getItem(TokenType.ID);
  const isAllowedPath = allowedRoutes.includes(pathname as RoutesMap);

  if (!idToken && !isAllowedPath) {
    return <Navigate to={RoutesMap.Login} />;
  }

  return <Outlet />;
};
